<template>
  <svg class="form__newsletter__icon__svg" v-bind:class="getClass()" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path d="M20 2H0v16h20V2zm-2 4l-8 5-8-5V4l8 5 8-5v2z" stroke="none"/>
  </svg>
</template>

<script>

export default{
  props: ["useAccentColor"],

  methods: {
    getClass() {
      if (this.useAccentColor) {
        return "accent-color";
      }
    }
  }
}
</script>
